<header class="modal-header">
  <h2 id="modal-title" class="modal-title">
    {{ title }}
  </h2>

  @if (!hideClose) {
    <button
      type="button"
      class="icon-button"
      aria-label="Close"
      (click)="close()">
      <app-display-icon [icon]="icons.close"></app-display-icon>
    </button>
  }
</header>
